import { render } from "./AddNote.vue?vue&type=template&id=4beaa349&scoped=true"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"

import "./AddNote.vue?vue&type=style&index=0&id=4beaa349&lang=scss&scoped=true"
import "./AddNote.vue?vue&type=style&index=1&id=4beaa349&lang=scss"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4beaa349"]])

export default __exports__